import LOCAL_STORAGE_KEYS from 'constants/localStorageKeys';
import { SET_IS_AUTHENTICATED, SET_PROFILE } from 'store/types/auth';
import { getFromLocalStorage } from 'utils/localStorage';

const initialState = {
  isAuthenticated: getFromLocalStorage(LOCAL_STORAGE_KEYS.TOKEN),
  me: null,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_IS_AUTHENTICATED:
      return {
        ...state,
        isAuthenticated: action?.payload,
      };
    case SET_PROFILE:
      return {
        ...state,
        me: action?.payload,
      };
    default:
      return state;
  }
};

export default authReducer;
